import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  user: any;

  constructor(
    private _apiSvc: ApiService,
    private _lsSvc: LocalStorageService
  ) { }

  /**
   * Get default store and sales person
   */
  getDefaults(): any {
    return this._apiSvc.get(`${this._apiSvc.endpoints.monolith}/api/User/currentUser`);
  }

  /**
   * Get user from local storage
   */
  private get _user(): any {
    return this._lsSvc.getItem('user');
  }

  /**
   * Get user's company id
   */
  getCompanyId(): number {
    return this._user.companyId;
  }

  /**
   * Get user's sales person id
   */
  getSalesPersonId(): number {
    return this._user.spid;
  }

    /**
   * Get user's sales person id
   */
     getDefaultStoreId(): number {
      return this._user.storeRefId;
    }

}
